import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { getSession, getCurrentAccount, getSavedPersonInfo } from "../../../reducers/selectors";
import { getQuestions, updateAnswers, getPersonInfo } from "../../../services/api/person";
import { currentAccountSet, personInfoSet } from "../../../actions/entities";

import { showToast } from "../../../utils/helper";

import style from "./Suitability.scss";

export const Suitability = ({ toggle }) => {
  const [start, setStart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [questions, setQuestions] = useState([]);
  const personInfo = useSelector(getSavedPersonInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(() => true);
    getQuestions()
      .then(({ response }) => {
        setQuestions(response.questions);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(() => false);
      });
  }, []);

  const setAnswer = (questionIndex, answerIndex) => {
    const newQuestions = [...questions];

    newQuestions.find((question) => question.QuestionId === questionIndex).Answer = newQuestions
      .find((question) => question.QuestionId === questionIndex)
      .Answer.map((answerItem) => {
        return {
          ...answerItem,
          AnswerIsResponse: false,
        };
      });

    newQuestions
      .find((question) => question.QuestionId === questionIndex)
      .Answer.find((answer) => answer.AnswerId === answerIndex).AnswerIsResponse = true;

    setQuestions(newQuestions);
  };

  const onConfirm = () => {
    const newQuestions = questions.filter((questionItem) => {
      if (questionItem.Answer.find((answerItem) => answerItem.AnswerIsResponse)) return questionItem;
    });

    if (newQuestions.length < questions.length) {
      showToast("Debe responder todas las preguntas", true);
      return;
    } else {
      setLoadingSave(() => true);
      updateAnswers({ sdtQuestion: questions })
        .then(({ response }) => {
          if (response.sdtresult.Code !== 200) showToast("Error enviando respuestas", true);
          else {
            getPersonInfo()
              .then(({ response }) => {
                dispatch(personInfoSet(response.personInfo));
                toggle("confirmation");
              })
              .catch((err) => console.error(err))
              .finally(() => {
                setLoadingSave(() => false);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  if (!personInfo || loading || loadingSave) return <CircularProgress />;

  return (
    <div className={style.profileTestWrapper}>
      <Fragment>
        <div className={style.header}>
          <span className={style.title}>Antes de continuar, completa el cuestionario:</span>
        </div>
        {questions.map((question, index) => {
          return <TestQuestion key={index} question={question} setAnswer={setAnswer} />;
        })}
      </Fragment>
      <span className={style.confirmContainer}>
        <Button
          className={style.confirmButton}
          onClick={() => {
            onConfirm();
          }}
        >
          confirmar datos
        </Button>
      </span>
    </div>
  );
};

const TestQuestion = ({ question, setAnswer }) => {
  const [active, setActive] = useState("");

  return (
    <form className={style.questionContainer}>
      <p className={style.questionTitle}>{question.QuestionDescription}</p>
      {question.Answer.map((answer, index) => {
        const key = `${question.QuestionId}-${index}`;

        return (
          <div key={key} className={`${style.answerRow} ${active == key ? style.answerRowActive : ""}`}>
            <input
              type="radio"
              name="answer"
              id={key}
              style={{ accentColor: "#EC7000" }}
              onClick={() => {
                setActive(key);
                setAnswer(question.QuestionId, answer.AnswerId);
              }}
            />
            <label className={style.answerText} for={key}>
              {answer.AnswerDescription}
            </label>
          </div>
        );
      })}
    </form>
  );
};
